import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@/i18n'; // i18next'ni ishga tushiradi (prerender sahifada: uz)
import '@/styles/index.css';
import App from './App';
import { InitialDataProvider, readInitialData } from '@/ssr/initialData';
import { isPrerenderedPage } from '@/ssr/hydration';

const container = document.getElementById('root')!;

const app = (
  <StrictMode>
    <InitialDataProvider value={readInitialData()}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </InitialDataProvider>
  </StrictMode>
);

// Prerender qilingan sahifa (nginx statik HTML) — mavjud markup ustiga hydrate.
// SPA shell (/_spa.html: profil, kontestlar...) — bo'sh #root, oddiy client render.
if (isPrerenderedPage()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
